import {Alert} from "antd";
import {useQuoteContext} from "../../../contexts/QuoteContext";

const AlertCancelled = ( ) => {
  const {quote} = useQuoteContext();

  // Assign alert message with increasing priority in following verifications.
  const quoteStatusAlert =
      (quote?.cancelled && !quote.archived) ? "Order is cancelled."
          :undefined;

  if ( !quoteStatusAlert ) return <></>

  return <div style={{marginBottom: "1rem"}}>
    <Alert
        type="info"
        showIcon
        message={quoteStatusAlert}
        style={{marginBottom: "1rem"}}
    />
  </div>
}

export default AlertCancelled;
